import { render, staticRenderFns } from "./ProcessSearch.vue?vue&type=template&id=6af3b2e6&"
import script from "./ProcessSearch.vue?vue&type=script&lang=js&"
export * from "./ProcessSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProcessSearch.vue?vue&type=style&index=0&id=6af3b2e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports